import { withFormik } from "formik";
import moment from "moment";
import * as Yup from "yup";
const currentTimestamp = Date.now();

const currentDate = new Date(currentTimestamp);
currentDate.setDate(1);
const year = currentDate.getFullYear();
const month = currentDate.getMonth();
const firstDayOfMonth = new Date(year, month, 1);

const ReportEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    startDate: Yup.string(),
    endDate: Yup.string()
  }),
  mapPropsToValues: props => ({
    startDate: firstDayOfMonth,
    endDate: new Date()
  }),
  validateOnMount: true,
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default ReportEnhancer;
